import {
  IParamsService,
  ParamsService,
} from './../../../../auxiliares/servicios/params.service';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IActivo,
  IConfigEventoUsuario,
  IDispositivoAlarma,
  IFilter,
  ILuminaria,
  IPopulate,
  IQueryParam,
  ITracker,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import { CrearEditarConfigEventoComponent } from '../crear-editar-config-evento/crear-editar-config-evento.component';

import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../auxiliares/tabla/tabla.component';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { IRegExpSearch } from '../../../../auxiliares/tabla/filtro/filtro.component';
import { LoginService } from '../../../login/login.service';
import { ConfigEventoUsuarioService } from '../../../../auxiliares/servicios/http/config-evento-usuario.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-configs-eventos',
  templateUrl: './listado-configs-eventos.component.html',
})
export class ListadoConfigsEventosComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ConfigEventoUsuarioService);
  private formularios = inject(FormularioDialogService);
  private paramsService = inject(ParamsService);

  //// Tabla nueva
  @Input() public dispositivo:
    | IDispositivoAlarma
    | IActivo
    | ITracker
    | ILuminaria;
  @Input() public tipo?: 'Alarma' | 'Activo' | 'Tracker' | 'Luminaria';
  @Input() public botonCrearMostrar?: boolean;
  public name = 'ListadoConfigsEventosComponent';
  public configsEventos?: IConfigEventoUsuario[];
  public configsEventos$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IConfigEventoUsuario>[];
  public botonCrear: ICrearBoton = {
    mostrar: false,
    tooltip: 'Crear tipo de evento',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crearConfigEvento(),
  };
  public search: IRegExpSearch = {
    fields: ['nombre'],
  };
  // FILTROS

  public filter: IFilter<IConfigEventoUsuario> = {
    codigoReportado: { $exists: true },
  };
  public populate: IPopulate[] = [
    {
      path: 'tracker',
      select: 'nombre',
    },
    // {
    //   path: 'luminaria',
    //   select: 'identificacion',
    // },
    {
      path: 'listadoCategoria',
      select: 'nombre',
    },
    {
      path: 'categoriaEvento',
      select: 'nombre',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: false,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    let filter: IFilter<IConfigEventoUsuario> = {};
    if (this.query.filter) {
      filter = JSON.parse(this.query.filter);
    }
    if (this.tipo === 'Alarma') {
      filter.idEntidad = (this.dispositivo as IDispositivoAlarma)._id;
    } else if (this.tipo === 'Luminaria') {
      filter.idEntidad = (this.dispositivo as ILuminaria)._id;
    } else if (this.tipo === 'Activo') {
      filter.idEntidad = (this.dispositivo as IActivo)?.idTracker;
    } else {
      filter.idEntidad = (this.dispositivo as ITracker)?._id;
    }
    this.query.filter = JSON.stringify(filter);
    //

    this.configsEventos$?.unsubscribe();
    this.configsEventos$ = this.lista2
      .configEventos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.configsEventos = data.datos;
      });
  }
  // Acciones
  public crearConfigEvento() {
    const params: IParamsService = {
      dispositivo: this.dispositivo,
    };
    this.paramsService.setParams(params);
    const config: { data?: unknown } = {};
    let res;
    if (this.tipo === 'Alarma') {
      config.data = { alarma: this.dispositivo };
      res = this.formularios.abrir(CrearEditarConfigEventoComponent, {
        tamano: 'mediano',
        data: config.data,
      });
    } else if (this.tipo === 'Luminaria') {
      config.data = { luminaria: this.dispositivo };
      res = this.formularios.abrir(CrearEditarConfigEventoComponent, {
        tamano: 'mediano',
        data: config.data,
      });
    } else {
      config.data = { activo: this.dispositivo };
      res = this.formularios.abrir(CrearEditarConfigEventoComponent, {
        tamano: 'mediano',
        data: config.data,
      });
    }
    if (res) {
      res.afterClosed().subscribe((r) => {
        if (r) {
          this.listar();
        }
      });
    }
  }

  public async editar(configEvento: IConfigEventoUsuario) {
    const config: { data?: unknown } = {};
    let res;
    if (this.tipo === 'Alarma') {
      config.data = {
        configEvento: configEvento,
        alarma: this.dispositivo,
      };
      res = this.formularios.abrir(CrearEditarConfigEventoComponent, {
        tamano: 'mediano',
        data: config.data,
      });
    } else if (this.tipo === 'Luminaria') {
      config.data = {
        configEvento: configEvento,
        luminaria: this.dispositivo,
      };
      res = this.formularios.abrir(CrearEditarConfigEventoComponent, {
        tamano: 'mediano',
        data: config.data,
      });
    } else {
      config.data = {
        configEvento: configEvento,
        activo: this.dispositivo,
      };
      res = this.formularios.abrir(CrearEditarConfigEventoComponent, {
        tamano: 'mediano',
        data: config.data,
      });
    }

    if (res) {
      res.afterClosed().subscribe((r) => {
        if (r) {
          this.listar();
        }
      });
    }
  }

  public async eliminar(configevento: IConfigEventoUsuario) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés eliminar el código personalizado ${configevento?.listadoCategoria?.nombre}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(configevento._id!);
      this.helper.notifSuccess('Código personalizado eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Tipo de evento',
        },
        row: {
          parse(dato) {
            return dato?.listadoCategoria?.nombre;
          },
          noData: 'Sin tipo de evento',
        },
      },
      {
        header: {
          label: 'Categoría',
        },
        row: {
          parse(dato) {
            return dato?.categoriaEvento?.nombre;
          },
          noData: 'Sin categoría',
        },
      },
      {
        header: {
          label: 'Área',
        },
        row: {
          parse(dato) {
            const partes: string[] = [];
            if (dato?.configZona?.particion)
              partes.push(`Partición: ${dato.configZona.particion}`);
            if (dato?.configZona?.zona)
              partes.push(`Zona: ${dato.configZona.zona}`);
            return partes.join(' · ');
          },
          noData: 'Sin zona',
        },
      },
      {
        header: {
          label: 'Notificación push',
          sortable: true,
          sort: 'notificar',
        },
        row: {
          parse: (dato) => (dato.notificar ? 'Sí' : 'No'),
        },
      },
      {
        header: {
          label: 'No derivar',
          sortable: true,
          sort: 'noDerivar',
        },
        row: {
          parse: (dato) => (dato.noDerivar ? 'Sí' : 'No'),
        },
      },

      {
        header: {
          label: 'Requiere atención',
          sortable: true,
          sort: 'atender',
        },
        row: {
          parse: (dato) => (dato.atender ? 'Sí' : 'No'),
        },
      },
      {
        header: {
          label: 'Acciones',
        },
        row: {
          acciones: [
            {
              tipo: 'material',
              color: 'primary',
              icon: 'edit',
              tooltip: 'Editar',
              click: (dato) => this.editar(dato),
            },
            {
              tipo: 'material',
              color: 'warn',
              icon: 'delete',
              tooltip: 'Eliminar',
              click: (dato) => this.eliminar(dato),
              disabled() {
                return LoginService.getUsuario()?._id === 'admin';
              },
            },
          ],
        },
      },
    ];
  }

  // Hooks

  async ngOnInit() {
    if (this.botonCrearMostrar === false) this.botonCrear.mostrar = false;
    else this.botonCrear.mostrar = true;
    this.setColumnas();
    Promise.all([this.listar()]);
  }

  async ngOnDestroy() {
    this.configsEventos$?.unsubscribe();
  }
}
